/**
 * The button colour a registration form starts with: blue `#2563eb`, the
 * same as `DEFAULT_EMBED_STYLING` in shared/schema.ts and the column's own
 * default (Andrew, 2026-10-31: "Keep it blue"). Both storages write it when
 * they create a form config and the Registration tab falls back to it, so a
 * new form, an unset colour and the database default all agree.
 *
 * No imports, deliberately: the client palette reads this file, and pulling
 * shared/schema.ts in with it would put drizzle in the first-load bundle.
 * tests/registrationButtonColour.test.ts pins it to the schema's default.
 */
export const SALEFISH_BRAND_HEX = "#452d8c";
/** The same purple, lifted for a dark surface. */
export const SALEFISH_BRAND_DARK_HEX = "#9d90d3";

export const REGISTRATION_BUTTON_COLOUR = "#2563eb";

/** Fill a new form config's styling: the stored default, with the default button. */
export function newFormEmbedStyling<T extends { buttonColor: string }>(defaults: T): T {
  return { ...defaults, buttonColor: REGISTRATION_BUTTON_COLOUR };
}
